/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import { toUTS } from 'global/utils';

import {
    speed,
    sweets,
    nz,
    breakfast,
    veg,
    forkids,
    menu,
    hits,
    creativity,
    guests,
    green,
    soups,
    hp,
    romantic,
    ny,
    maxim,
    hochland,
    christmas,
    maslenitsa,
    marchgifts,
    march,
    fasting,
    YaP,
    easter,
    dacha,
    squidgame,
    film,
    halloween,
    biomio,
    parents,
    odyssey,
    gryadka,
} from 'app/assets/dishesSelections/dishesSelections';

import { periods as hpPeriods } from 'global/const/hp';
import { periods as romanticPeriods } from 'global/const/romantic';
// import { periods as hochlandPeriods } from 'global/const/hochland';
import { periodsForSelection as easterPeriods } from 'global/const/easter';
import { periods as maslenitsaPeriods } from 'global/const/maslenitsa';
import { periods as marchgiftsPeriods } from 'global/const/marchgifts';
import { periods as marchPeriods } from 'global/const/march';
// import { periods as YaPPeriods } from 'global/const/yapracticum';
// import { periods as squidgamePeriods } from 'global/const/squidgame';
// import { periods as hlwPeriods } from 'global/const/halloween';
// import { periods as nyPeriods, NYPeriodStart, NYPeriodStartRegions } from 'global/const/ny';

import { isDesktop } from 'app/utils/resolution';
import { isDateInRange } from 'app/containers/contexts/filters.context/filters.context';


type TPayload = {
    selectedPeriod: string,
    availableLinks: any,
}

type TBannerType = 'link' | 'selection' | 'action/close' | 'detail';

export type TActiveSelectionKeys = '1220' | '1809' | '1218' | '1218' | '2028' |
    'soups' | 'kids' | 'hits' | 'creativity' | 'guests' | 'christmas' | 'ny' | 'hp'
    | 'march' | 'maslenitsa' | 'sweets' | 'breakfast' | 'film' | 'march' | 'marchgifts' | '2121' | 'YaP' | 'easter'
    | 'squidgame' | 'maxi_kids' | 'maxi_sauces' | 'maxi_gryadka' | 'halloween' | 'marchgifts'
    | 'parents' | 'odyssey' | 'gryadka' | 'maxi_harry';

export type TActiveLinks = 'menu';

type TBannersMeta = {
    // eslint-disable-next-line no-unused-vars
    check: (data: TPayload) => boolean,
    title: React.ReactElement | string
    backgroundImagePath: string
    preloadImage: string,
    id: string
    tag: TActiveSelectionKeys | TActiveLinks,
    type: TBannerType,
    href?: string,
    savingDeliveryСartText?: string
}

export const selectionRecord: Array<TBannersMeta> = [
    {
        check: (props) => [
            '2026-08-10',
            '2026-08-17',
            '2026-08-24',
            '2026-08-31',
        ].some((p) => isDateInRange(p, props.selectedPeriod, 1)),
        title: <>
            С грядки
            <br />
            из деревни
        </>,
        backgroundImagePath: gryadka.xs,
        preloadImage: gryadka.m,
        id: 'gryadka',
        tag: 'gryadka',
        type: 'selection',
    },
    {
        check: (props) => [
            '2026-06-01',
            '2026-06-08',
        ].some((p) => isDateInRange(p, props.selectedPeriod, 1)),
        title: '',
        backgroundImagePath: parents.xs,
        preloadImage: '',
        id: 'parents',
        tag: 'parents',
        type: 'selection',
    },
    {
        check: (props) => {
            if (isDesktop()) return false;
            return true;
        },
        title: <>Детское<br />меню</>,
        backgroundImagePath: forkids.xs,
        preloadImage: forkids.m,
        id: 'kids',
        tag: 'kids',
        type: 'selection',
    },
    {
        check: (props) => {
            if (isDesktop()) return false;
            return true;
        },
        title: '',
        backgroundImagePath: green.xs,
        preloadImage: green.m,
        id: 'green',
        tag: '1220',
        type: 'selection',
    },
    {
        check: (props) => {
            if (isDesktop()) return false;
            return true;
        },
        title: <>Время для<br />творчества</>,
        backgroundImagePath: creativity.xs,
        preloadImage: creativity.m,
        id: 'creativity',
        tag: 'creativity',
        type: 'selection',
    },
    {
        check: (props) => {
            if (isDesktop()) return false;
            return toUTS(props.selectedPeriod) > toUTS('2026-01-05');
        },
        title: <>К приходу<br />гостей</>,
        backgroundImagePath: guests.xs,
        preloadImage: guests.m,
        id: 'guests',
        tag: 'guests',
        type: 'selection',
    },
    {
        check: (props) => {
            if (isDesktop()) return false;
            return true;
        },
        title: <>Хиты<br />вне времени</>,
        backgroundImagePath: hits.xs,
        preloadImage: hits.m,
        id: 'hits',
        tag: 'hits',
        type: 'selection',
    },
    {
        check: (props) => {
            if (isDesktop()) return false;
            return toUTS(props.selectedPeriod) > toUTS('2026-01-04');
        },
        title: <>Супы<br />за 5-15 минут</>,
        backgroundImagePath: soups.xs,
        preloadImage: soups.m,
        id: 'soups',
        tag: 'soups',
        type: 'selection',
    },
    {
        check: (props) => {
            if (isDesktop()) return false;
            return true;
        },
        title: <>Вег-меню<br />Лучшее</>,
        backgroundImagePath: veg.xs,
        preloadImage: veg.m,
        id: 'veg',
        tag: '1218',
        type: 'selection',
    },
    {
        check: () => !isDesktop(),
        title: <>Готовим<br /> за 15 мин!</>,
        backgroundImagePath: speed.xs,
        preloadImage: speed.m,
        id: 'fast',
        tag: '1809',
        type: 'selection',
    },
    {
        check: () => !isDesktop(),
        title: <>Печём <br /> вместе</>,
        backgroundImagePath: sweets.xs,
        preloadImage: sweets.m,
        id: 'sweets',
        tag: 'sweets',
        type: 'selection',
    },
    {
        check: (props) => {
            if (isDesktop()) return false;
            return true;
        },
        title: <>Богемные <br /> завтраки</>,
        backgroundImagePath: breakfast.xs,
        preloadImage: breakfast.m,
        id: 'breakfast',
        tag: 'breakfast',
        type: 'selection',
    },
    {
        check: (props) => {
            if (isDesktop()) return false;
            return true;
        },
        title: <>Про запас</>,
        backgroundImagePath: nz.xs,
        preloadImage: nz.m,
        id: 'nz',
        tag: '2028',
        type: 'selection',
    },
    // FOR DESKTOP UPSELL
    {
        check: (props) => {
            if (isDesktop()) return false;
            return true;
        },
        title: <>Все блюда<br />меню</>,
        backgroundImagePath: menu.xs,
        preloadImage: menu.xs,
        id: 'menu',
        tag: 'menu',
        type: 'link',
        href: '/menu',
    },
    // {
    //     check: (props) => [
    //         '2026-08-10',
    //         '2026-08-17',
    //         '2026-08-24',
    //         '2026-08-31',
    //     ].some((p) => isDateInRange(p, props.selectedPeriod, 1)),
    //     title: <>Едем <br />на шашлыки</>,
    //     backgroundImagePath: dacha.xs,
    //     preloadImage: dacha.m,
    //     id: 'dacha',
    //     tag: 'dacha',
    //     type: 'link',
    //     href: '/dacha',
    // },
    // {
    //     check: (props) => {
    //         if (isDesktop()) return false;
    //         return easterPeriods.some((p) => isDateInRange(p, props.selectedPeriod, 1));
    //     },
    //     title: <>
    //         Пасхальное
    //         <br />
    //         меню
    //     </>,
    //     backgroundImagePath: easter.xs,
    //     preloadImage: easter.m,
    //     id: 'march',
    //     tag: 'march',
    //     type: 'link',
    //     href: '/easterbox',
    // },
    // {
    //     check: (props) => {
    //         if (isDesktop()) return false;
    //         return ['2026-04-06'].some((p) => isDateInRange(p, props.selectedPeriod, 1));
    //     },
    //     title: <>
    //         Пасхальное
    //         <br />
    //         меню
    //     </>,
    //     backgroundImagePath: easter.xs,
    //     preloadImage: easter.m,
    //     id: '4443',
    //     tag: 'march',
    //     type: 'detail',
    // },
    // {
    //     check: (props) => {
    //         if (isDesktop()) return false;
    //         return marchPeriods.some((p) => isDateInRange(p, props.selectedPeriod, 1));
    //     },
    //     title: <>Великие<br />женщины</>,
    //     backgroundImagePath: march.xs,
    //     preloadImage: march.m,
    //     id: 'march',
    //     tag: 'march',
    //     type: 'selection',
    // },
    // {
    //     check: (props) => {
    //         if (isDesktop()) return false;
    //         return [
    //             '2026-02-09',
    //         ].some((p) => isDateInRange(p, props.selectedPeriod, 1));
    //     },
    //     title: <>
    //         Масленицa
    //         <br />
    //         с Tefal
    //     </>,
    //     backgroundImagePath: maslenitsa.xs,
    //     preloadImage: maslenitsa.m,
    //     id: 'maslenitsa',
    //     tag: 'maslenitsa',
    //     href: '/maslenitsa/',
    //     type: 'link',

    // },
    // {
    //     check: (props) => {
    //         if (isDesktop()) return false;
    //         return hpPeriods.some((p) => isDateInRange(p, props.selectedPeriod, 1));
    //     },
    //     title: (
    //         <>
    //             Меню
    //             <br />
    //             из&nbsp;Хогвартса
    //         </>
    //     ),
    //     backgroundImagePath: hp.xs,
    //     preloadImage: hp.m,
    //     id: 'hp',
    //     tag: 'hp',
    //     type: 'selection',
    // },
    // {
    //     check: (props) => {
    //         if (isDesktop()) return false;
    //         return [
    //             '2026-03-23',
    //             '2026-03-30',
    //             '2026-04-06',
    //         ].some((p) => isDateInRange(p, props.selectedPeriod, 1));
    //     },
    //     title: <>Постное<br />меню</>,
    //     backgroundImagePath: fasting.xs,
    //     preloadImage: fasting.m,
    //     id: 'fasting',
    //     tag: '2121',
    //     type: 'selection',
    // },
    // {
    //     check: (props) => [
    //         '2026-08-03',
    //         '2026-08-10',
    //     ].some((p) => isDateInRange(p, props.selectedPeriod, 1)),
    //     title: <>
    //         К фильму
    //         <br />
    //         «Одиссея»
    //     </>,
    //     backgroundImagePath: odyssey.xs,
    //     preloadImage: odyssey.m,
    //     id: 'odyssey',
    //     tag: 'odyssey',
    //     type: 'selection',
    // },
    // {
    //     check: (props) => [
    //         '2026-04-13',
    //         '2026-04-20',
    //         '2026-04-27',
    //     ].some((p) => isDateInRange(p, props.selectedPeriod, 1)),
    //     title: <>
    //         Полезные
    //         <br />
    //         привычки
    //     </>,
    //     backgroundImagePath: biomio.xs,
    //     preloadImage: '',
    //     id: 'biomio',
    //     tag: 'biomio',
    //     type: 'link',
    //     href: '/biomio',
    // },
    // {
    //     check: (props) => {
    //         if (isDesktop()) return false;
    //         return marchgiftsPeriods
    //             .some((p) => isDateInRange(p, props.selectedPeriod, 1));
    //     },
    //     title: <>
    //         Подарки
    //         <br />
    //         к 8 марта
    //     </>,
    //     backgroundImagePath: marchgifts.xs,
    //     preloadImage: marchgifts.xs,
    //     id: 'marchgifts',
    //     tag: 'marchgifts',
    //     type: 'link',
    //     href: '/marchgifts',
    // },
    // {
    //     check: (props) => {
    //         if (isDesktop()) return false;
    //         return romanticPeriods
    //             .some((p) => isDateInRange(p, props.selectedPeriod, 1));
    //     },
    //     title: (
    //         <>
    //             Время
    //             <br />
    //             свиданий
    //             <br />
    //             дома
    //         </>
    //     ),
    //     backgroundImagePath: romantic.xs,
    //     preloadImage: romantic.m,
    //     id: 'romantic',
    //     tag: 'romantic',
    //     href: '/romantic',
    //     type: 'link',
    //     // type: 'detail',
    // },
    // {
    //     check: (props) => {
    //         if (isDesktop()) return false;
    //         return maslenitsaPeriods
    //             .filter((p) => p !== '2026-02-09')
    //             .some((p) => isDateInRange(p, props.selectedPeriod, 1));
    //     },
    //     title: <>Масленицa
    //         <br />
    //         с Tefal
    //     </>,
    //     backgroundImagePath: maslenitsa.xs,
    //     preloadImage: maslenitsa.m,
    //     id: 'maslenitsa',
    //     tag: 'maslenitsa',
    //     type: 'selection',
    // },
    // {
    //     check: (props) => {
    //         if (isDesktop()) return false;
    //         return true;
    //     },
    //     title: '',
    //     backgroundImagePath: christmas.xs,
    //     preloadImage: christmas.m,
    //     id: 'ny',
    //     tag: 'ny',
    //     type: 'link',
    //     href: '/christmas/',
    // },
    // {
    //     check: (props) => {
    //         if (isDesktop()) return false;
    //         return hlwPeriods.includes(props.selectedPeriod);
    //     },
    //     title: <>
    //         Бокс на
    //         <br />
    //         Хэллоуин
    //     </>,
    //     backgroundImagePath: halloween.xs,
    //     preloadImage: halloween.xs,
    //     id: 'halloween',
    //     tag: 'halloween',
    //     type: 'link',
    //     href: '/halloweenalfa/?save=dishes',
    // },
    // {
    //     check: () => {
    //         if (isDesktop()) return false;
    //         return true;
    //     },
    //     title: <>Дома<br />как в кино</>,
    //     backgroundImagePath: film.xs,
    //     preloadImage: film.m,
    //     id: 'film',
    //     tag: 'film',
    //     type: 'selection',
    // },
    // {
    //     check: (props) => !isDesktop() && squidgamePeriods.includes(props.selectedPeriod),
    //     title: <>Игра<br />в кальмара</>,
    //     backgroundImagePath: squidgame.xs,
    //     preloadImage: squidgame.m,
    //     id: 'squidgame',
    //     tag: 'squidgame',
    //     type: 'selection',
    // },
    // {
    //     check: (props) => {
    //         if (isDesktop()) return false;
    //         return YaPPeriods.includes(props.selectedPeriod);
    //     },
    //     title: '',
    //     backgroundImagePath: YaP.xs,
    //     preloadImage: YaP.m,
    //     id: 'YaP',
    //     tag: 'YaP',
    //     type: 'selection',
    // },
];

const excludeBannerByPeriod = (
    record: any[], bannerToExclude: string[],
) => record.filter((item: TBannersMeta) => !bannerToExclude.includes(item.id));


// eslint-disable-next-line arrow-body-style
export const getSelectionRecord = (data: TPayload) => {
    if (data.selectedPeriod === '2025-12-30') {
        const nyBanners = ['ny', 'fast', 'sweets'];
        return selectionRecord.filter((item: TBannersMeta) => nyBanners.includes(item.id));
    }

    if (data.selectedPeriod === '2026-01-04') {
        return excludeBannerByPeriod(selectionRecord, ['ny', 'soups']);
    }

    if (data.selectedPeriod === '2026-01-05') {
        return excludeBannerByPeriod(selectionRecord, ['ny', 'guests']);
    }

    if (data.selectedPeriod === '2026-01-12') {
        return excludeBannerByPeriod(selectionRecord, ['ny']);
    }

    return selectionRecord.filter((item: TBannersMeta) => item.check(data));
};


/**
    * Example
    */
// {
//     check: (props) => {
//         if (isDesktop()) return false;
//         return maslenitsaPeriods.includes(props.selectedPeriod);
//     },
//     title: <>Масленица</>,
//     backgroundImagePath: maslenitsa.xs,
//     preloadImage: maslenitsa.m,
//     id: 'maslenitsa',
//     tag: 'maslenitsa',
//     type: 'selection',
// },
// {
//     check: () => true,
//     title: <>Десерты<br />и выпечка</>,
//     backgroundImagePath: sweet.xs,
//     type: 'link',
//     id: 'sweet',
//     tag: 'sweet',
//     href: SWEET_PAGE.hrefRu,
// },
// {
//     check: (props) => {
//         const periods = ['2022-02-28', '2022-03-07'];
//         return periods.includes(props.selectedPeriod);
//     },
//     title: <>Меню<br />8 марта</>,
//     backgroundImagePath: special.xs,
//     preloadImage: special.m,
//     id: 'special',
//     tag: '2110',
// },
// {
//     check: (props) => {
//         if (isDesktop()) return false;
//         const periods = ['2022-10-10', '2022-10-17'];
//         return periods.includes(props.selectedPeriod);
//     },
//     title: (
//         <>
//             Меню
//             <br />
//             Oktoberfest
//         </>
//     ),
//     backgroundImagePath: special.xs,
//     preloadImage: special.m,
//     id: 'special',
//     tag: 'special',
// },

// {
//     check: (props) => {
//         if (isDesktop()) return false;
//         return hpPeriods.includes(props.selectedPeriod);
//     },
//     title: (
//         <>
//             Меню
//             <br />
//             из&nbsp;Хогвартса
//         </>
//     ),
//     backgroundImagePath: hp.xs,
//     preloadImage: hp.m,
//     id: 'hp',
//     tag: 'hp',
//     type: 'selection',
// },
